
export default {
  props: {
    classProp: {
      type: String,
      default: " border-2 mt-10 pa-5 circle-close-btn"
    }
  }
};
